import * as purchaseOrderActions from './managePurchasseOrder/actions';

export const actions = {
  ...purchaseOrderActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/actions.js